import { LabelModule } from './../../../shared/component/common/label/label.module';
import { ButtonModule } from './../../../shared/component/common/button/button.module';
import { HeaderModule } from './../../../shared/component/common/header/header.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';


import { TaxResidencyPageComponent } from './tax-residency.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    HeaderModule,
    ButtonModule,
    LabelModule,
  ],
  declarations: [TaxResidencyPageComponent]
})
export class TaxResidencyPageModule {}
